<template>
  <div class="error-msg">
    <b-message type="is-danger">
      {{ jobErrorState }}
    </b-message>
  </div>
</template>

<script>

import {mapGetters} from 'vuex';

export default {
  computed: {
    ...mapGetters(['jobErrorState'])
  }
};
</script>

<style lang="scss" scoped>
@import '~VariablesStyles';

@media screen and (min-width: $tablet) {
  .error-msg {
    padding: 0 100px;
  }
}
</style>
